module.exports = __webpack_public_path__ + "static/media/iosApp.986f8a5a.png";